module.exports = __webpack_public_path__ + "img/logo.0e38e3b0.png";